import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function EditEmailNotifications() {
  const sections = [{
    title: 'Site administrator notifications',
    items: ['Notify the site administrator by email if unallowed request to site occurs', 'Notify admin of bad logins']
  }, {
    title: 'Orders department notifications',
    items: ['Enable email notifications to the orders department about placed orders', "'Order is processed' notification to orders department"]
  }, {
    title: 'Users department notifications',
    items: ["'Profile is created' notification to users department", "'Profile is modified' notification to users department", "'Profile is deleted' notification to users department"]
  }, {
    title: 'Customer notifications',
    items: ['Enable email notifications for customers about initially placed orders', "'Order is processed' notification to customer", "'Order is completed' notification to customer:", "'Order is declined' notification to orders department", "'Profile is created' notification to profile owner:", "'Profile is modified' notification to profile owner", "'Profile is deleted' notification to profile owner"]
  }];
  return <div className="space-y-6 max-w-4xl mx-auto" data-id="element-227">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-228">
        Edit E-mail Notifications
      </h1>

      <Card data-id="element-229">
        <CardContent className="space-y-8 pt-6" data-id="element-230">
          {sections.map(section => <div key={section.title} className="space-y-4" data-id="element-231">
              <h3 className="text-lg font-semibold text-slate-900 border-b border-slate-200 pb-2" data-id="element-232">
                {section.title}
              </h3>
              <div className="space-y-3 pl-2" data-id="element-233">
                {section.items.map(item => <label key={item} className="flex items-start gap-3 cursor-pointer group" data-id="element-234">
                    <input type="checkbox" className="mt-1 rounded border-slate-300 text-slate-900 focus:ring-slate-900" data-id="element-235" />
                    <span className="text-sm text-slate-700 group-hover:text-slate-900 transition-colors" data-id="element-236">
                      {item}
                    </span>
                  </label>)}
              </div>
            </div>)}

          <div className="pt-4 border-t border-slate-200" data-id="element-237">
            <Button data-id="element-238">Submit</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}